/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge3 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important;
							height: ${getCssDemention(props.item.position?.height, "auto")}!important; 
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])
	return <div className={`w-100 flex-centered edge-${id}  delimiter-edge-10`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		> 
			<rect fill={props.item.fill || "var(--force-contast-color)"} x="233.5" y="7.6" transform="matrix(0.7071 0.7071 -0.7071 0.7071 90.7079 -169.9446)" width="33.9" height="33.9"/>
			<rect fill={props.item.fill || "var(--force-contrast-opacity-color)"} x="284.5" y="14.6" transform="matrix(0.7071 0.7071 -0.7071 0.7071 103.5549 -200.96)" width="19.8" height="19.8"/>
			<rect fill={props.item.fill || "var(--force-contrast-opacity-color)"} x="318.3" y="14.6" transform="matrix(0.7071 0.7071 -0.7071 0.7071 113.4786 -224.9179)" width="19.8" height="19.8"/>
			<rect fill={props.item.fill || "var(--force-contrast-opacity-color)"} x="352.2" y="14.6" transform="matrix(0.7071 0.7071 -0.7071 0.7071 123.4022 -248.8758)" width="19.8" height="19.8"/>
			<rect fill={props.item.fill || "var(--force-contrast-opacity-color)"} x="104.1" y="18.4" transform="matrix(0.7071 0.7071 -0.7071 0.7071 49.6377 -70.7923)" width="12.3" height="12.3"/>
			<rect fill={props.item.fill || "var(--force-contrast-opacity-color)"} x="384.6" y="18.4" transform="matrix(0.7071 0.7071 -0.7071 0.7071 131.7781 -269.0969)" width="12.3" height="12.3"/>
			<rect fill={props.item.fill || "var(--force-contrast-opacity-color)"} x="129" y="14.6" transform="matrix(0.7071 0.7071 -0.7071 0.7071 58.0135 -91.0135)" width="19.8" height="19.8"/>
			<rect fill={props.item.fill || "var(--force-contrast-opacity-color)"} x="162.9" y="14.6" transform="matrix(0.7071 0.7071 -0.7071 0.7071 67.9372 -114.9713)" width="19.8" height="19.8"/>
			<rect fill={props.item.fill || "var(--force-contrast-opacity-color)"} x="196.7" y="14.6" transform="matrix(0.7071 0.7071 -0.7071 0.7071 77.8609 -138.9292)" width="19.8" height="19.8"/>
			
		</svg>
	</div>
}

